import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Criação de atestado servida pelo quarkus.
export function useSaveAttested() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((attested) => {
    setSaving(true);
    return quarkusApi
      .post('/atestado', attested, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
